import axios from "axios";
import { ENDPOINTS } from "./_config";

/* ========= API CALLS ========= */
export const getAllEclinProTrials = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      ENDPOINTS.ECLINPRO.GET_ALL_ECLINPRO_TRIALS,
      {
        headers: {
          accept: "text/plain",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("EclinPro Trials API error:", error);
    return { data: { data: [] } };
  }
};

export const linkEclinProTrial = async (payload) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      ENDPOINTS.ECLINPRO.LINK_ECLINPRO_TRIAL,
      payload,
      {
        headers: {
          accept: "text/plain",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Link EclinPro Trial API Error:", error);
    throw error;
  }
};

export const getEclinProConnectedTrial = async (trialID) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      ENDPOINTS.ECLINPRO.GET_ECLINPRO_CONNECTED_TRIAL,
      {
        params: { trialID },
        headers: {
          accept: "text/plain",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Get EclinPro Connected Trial API Error:", error);
    throw error;
  }
};

export const delinkEclinProTrial = async (payload) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      ENDPOINTS.ECLINPRO.DELINK_ECLINPRO_TRIAL,
      payload,
      {
        headers: {
          accept: "text/plain",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Delink EclinPro Trial API Error:", error);
    throw error;
  }
};